export default __webpack_public_path__ + "static/media/dashboard.0c3147e2.png";